import * as React from 'react'
import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next'
import cn from 'classnames'
import HKFlag from 'images/flags/hk.jpg'
import * as styles from './styles.module.css'

const langMap = {
  'zh_HK': '繁體中文',
  'en_US': 'English'
}

const FooterSection = () => {
  const { t } = useTranslation()
  const {language} = useI18next()
  return (
    <>
      <div className={cn(styles.footer)}>
        <div className={styles.separator} />
        <div className={styles.section}>
          <p>{t('footer.license')}</p>
          <div className={styles.langSection}>
            <img className={styles.flag} src={HKFlag} alt='' />
            <p>{t('footer.hk')}</p>
            <p>{`(${langMap[language]})`}</p>
          </div>
        </div>
      </div>
    </>
  )
}

export default FooterSection